import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AssetPickerModalComponent } from "./asset-picker.modal.component";
import { AssetHierarchyResponse } from "source/app/configuration/services/api.service";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class AssetPickerModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = async (assets: AssetHierarchyResponse) => {
		return this.modalController.create({
			id: AssetPickerModalComponent.modalId,
			component: AssetPickerModalComponent,
			cssClass: this.rideOpsUi.isV2Active()
				? "asset-picker-modal asset-picker-modal-v2"
				: "asset-picker-modal",
			componentProps: {
				assetHierarchy: assets,
			},
		});
	};
}
